import { groupStore } from "../store/label-group";
import CreateGroupView from "../views/CreateGroupView.vue";
export default {
  path: "/label-group",
  name: "CreateGroup",
  component: CreateGroupView,
  meta: {
    requiresAuth: true,
    roles: ["ADMIN"],
  },
  beforeEnter: (to, from, next) => {
  if (from.name !== "RobotSession" && from.name !== "MonitoringStation") {
    groupStore.clear();
  }
    groupStore.updateAllLabels();
    return next();
  },
};
